import { requestApi } from 'api/Api';

export const createWeightLossAdministration = (navigate, params, onError, onSuccess) =>
  requestApi({
    navigate,
    url: '/api/weight_loss_administration/create',
    params,
    onError,
    onSuccess
  });

export const getWeightLossAdministration = (navigate = () => {}, params) =>
  requestApi({ navigate, url: '/api/weight_loss_administration/get', params });

export const deleteWeightLossAdministration = (navigate = () => {}, params) =>
  requestApi({ navigate, url: '/api/weight_loss_administration/delete', params });

export const deleteMultipleWeightLossAdministration = (navigate = () => {}, params) =>
  requestApi({ navigate, url: '/api/weight_loss_administration/multiple_delete', params });

export const updateMultipleWeightLossAdministration = (navigate = () => {}, params) =>
  requestApi({ navigate, url: '/api/weight_loss_administration/multiple_update', params });
